import { selectCurrentUserIsAdminOrOwner } from 'ducks/currentUser/selectors'
import {
  selectFlag,
  selectIsFetchingFlags,
  selectByName,
} from 'ducks/flags/selectors'
import { selectIsBillingPage } from 'subapps/settings/selectors'
import { selectAnnualOffer } from './selectAnnualOffer'
import { selectBillingEstimate } from './selectBillingEstimate'
import { selectFuturePhase } from './selectFuturePhase'
import { selectNextBillDate } from './selectNextBillDate'

export const selectShowAnnualBillingReminder = (
  state,
  nowEpochSeconds,
  yearlySaving
) => {
  const offer = selectAnnualOffer(state)
  if (
    offer?.surfaces?.reminder !== true ||
    offer.promotion ||
    !selectCurrentUserIsAdminOrOwner(state) ||
    selectIsBillingPage(state) ||
    !Number.isFinite(yearlySaving) ||
    yearlySaving <= 0 ||
    !Number.isFinite(nowEpochSeconds) ||
    selectIsFetchingFlags(state) !== false ||
    !selectByName(state)
  )
    return false

  // selectNextBillDate falls back to now; require actual API renewal data first.
  const actualRenewal =
    selectBillingEstimate(state)?.nextBillDate ||
    selectFuturePhase(state)?.startDate
  if (!Number.isInteger(actualRenewal) || actualRenewal <= 0) return false
  const nextBillDate = selectNextBillDate(state)
  const remaining = nextBillDate - nowEpochSeconds
  const flag = selectFlag(state)
  return (
    remaining >= 0 &&
    remaining <= 604800 &&
    flag('annual_reminder_dismissed') === false &&
    flag(`annual_reminder_snoozed_${nextBillDate}`) === false
  )
}

export default selectShowAnnualBillingReminder
